import React from 'react';
import { toLower } from 'lodash';

const SearchEventContext = React.createContext({});

export function SearchEventProvider({ children }) {
  const [displayMenu, setDisplayMenu] = React.useState(false);
  const [displaySelect, setDisplaySelect] = React.useState(false);
  const [displayFormInputs, setDisplayFormInputs] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState('');
  const [searchCurrValue, setSearchCurrValue] = React.useState('');
  const [selectEventType, setSelectEventType] = React.useState('');
  const [selectEventDepartment, setSelectEventDepartment] = React.useState('');
  const [clear, setClear] = React.useState(false);
  const [listing, setListing] = React.useState('grid');
  const [eventsList, setEventsList] = React.useState([]);
  const [searchBtnClick, setSearchBtnClick] = React.useState(false);
  const [eventFilterArray, setEventFilterArray] = React.useState([
    searchValue,
    toLower(selectEventType) === 'event type' ? '' : selectEventType,
    toLower(selectEventDepartment) === 'industry' ? '' : selectEventDepartment,
  ]);
  const [totalFilteredEvents, setTotalFilteredEvents] = React.useState(eventsList.length);

  React.useEffect(
    () =>
      setEventFilterArray([
        searchCurrValue,
        toLower(selectEventType) === 'event type' ? '' : selectEventType,
        toLower(selectEventDepartment) === 'industry' ? '' : selectEventDepartment,
      ]),
    [searchCurrValue, selectEventType, selectEventDepartment],
  );

  React.useEffect(() => {
    if (displayMenu) setTimeout(() => setDisplayFormInputs(true), 200);
    else setDisplayFormInputs(false);
  }, [displayMenu]);

  const memo = {
    clear,
    displayFormInputs,
    displayMenu,
    displaySelect,
    eventFilterArray,
    eventsList,
    listing,
    searchBtnClick,
    searchCurrValue,
    searchValue,
    selectEventDepartment,
    selectEventType,
    setClear,
    setDisplayMenu,
    setDisplaySelect,
    setEventFilterArray,
    setEventsList,
    setListing,
    setSearchBtnClick,
    setSearchCurrValue,
    setSearchValue,
    setSelectEventDepartment,
    setSelectEventType,
    totalFilteredEvents,
    setTotalFilteredEvents,
  };

  const value = React.useMemo(() => memo, [memo]);

  return <SearchEventContext.Provider value={value}>{children}</SearchEventContext.Provider>;
}

export default SearchEventContext;
